import { ROLE_PREVIEW_PARAM } from '../Auth/rbac/rolePreviewOverride';
import { STARTER_PLAN_PARAM } from '../entitlements/starterPreviewOverride';

// Params describing the SESSION rather than the page: an allowlist, so page-scoped junk (activeTab,
// simulationId, date ranges) does not follow the user somewhere it means nothing. All three live
// only in the URL at this point — `presenter_mode` permanently, the previews until init promotes
// them to localStorage — so dropping one silently ends a demo or a support preview.
const APP_GLOBAL_PARAMS = ['presenter_mode', ROLE_PREVIEW_PARAM, STARTER_PLAN_PARAM];

/**
 * Builds the query string for a redirect away from the current page, keeping the app-global
 * params and setting `team_id` when it is known.
 */
export function carryGlobalParams(currentSearch: string, teamId?: number | null): string {
  const incoming = new URLSearchParams(currentSearch || '');
  const carried = new URLSearchParams();

  APP_GLOBAL_PARAMS.forEach((key) => {
    const value = incoming.get(key);
    if (value != null) carried.set(key, value);
  });

  if (teamId) carried.set('team_id', String(teamId));

  const search = carried.toString();
  return search ? `?${search}` : '';
}
